import { Component, Vue } from 'vue-property-decorator';
import { TelstraUIVueSvg } from '@/external/telstra-ui-vue/components';
import { AppStoreModule } from '@/store';
import AppStore from '@/store/modules/AppStoreModule';
import { nav } from '@/_nav';

@Component({
  components: {
    TelstraUIVueSvg,
  },
})
export default class TelstraUIVueSideNav extends Vue {
  app$: AppStore = AppStoreModule;
  navItems: any = nav.items;

  get drawer(): boolean {
    return this.app$.isDrawerOpen;
  }

  set drawer(isOpen: boolean) {
    this.app$.setIsDrawerOpen(isOpen);
  }

  get mini(): boolean {
    return this.app$.isSidenavMini;
  }

  set mini(isMini: boolean) {
    this.app$.setIsSidenavMini(isMini);
  }

}
